import { render, staticRenderFns } from "./CorrespondenceThreadShow.vue?vue&type=template&id=48cd0929&"
import script from "./CorrespondenceThreadShow.vue?vue&type=script&lang=js&"
export * from "./CorrespondenceThreadShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports